import { render } from "./NativeFieldsCard.vue?vue&type=template&id=37d4a0fa&scoped=true"
import script from "./NativeFieldsCard.vue?vue&type=script&lang=js"
export * from "./NativeFieldsCard.vue?vue&type=script&lang=js"

import "./NativeFieldsCard.vue?vue&type=style&index=0&id=37d4a0fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d4a0fa"]])

export default __exports__